module.exports = __webpack_public_path__ + "static/media/hockey_finder.b1dbcf42.png";